import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import api from "../../api";
import Slider from "react-slick";
import { FaHeart } from "react-icons/fa";

function Similar_Product({ url }) {
  const navigate = useNavigate();

  const [cardImage, setCardImage] = React.useState([]);
  const [loading, setLoading] = React.useState(true);
  const accessToken = localStorage.getItem("accessToken");

  useEffect(() => {
    CardData();
  }, [url]);
  const CardData = async () => {
    try {
      const response = await api.get(url);
      console.log("iudhfkudf", response.data);

      if (response.data.status == "success") {
        setCardImage(response.data.product_list);
      }
    } catch (error) {
      console.log(error);
    }
  };

  function SampleNextArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.29)",
          height: "auto",
          padding: "3px",
          width: "26px",
          borderRadius: "10px 50px 50px 10px",
        }}
        onClick={onClick}
      />
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props;
    return (
      <div
        className={className}
        style={{
          ...style,
          display: "block",
          position: "absolute",
          backgroundColor: "rgba(0, 0, 0, 0.29)",
          height: "auto",
          padding: "3px",
          width: "26px",
          borderRadius: "50px 10px 10px 50px",
        }}
        onClick={onClick}
      />
    );
  }
  // console.log(cardImage);
  const settings = {
    infinite: true,
    speed: 5000,
    slidesToShow: 6,
    slidesToScroll: 1,
    arrows: true,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      {
        breakpoint: 1500,
        settings: {
          slidesToShow: 6,
        },
      },

      {
        breakpoint: 990,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 800,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 590,
        settings: {
          slidesToShow: 3,
        },
      },

      {
        breakpoint: 430,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const handelRefresh = (product_url) => {
    navigate(`/Product_details_final/${product_url}`);
    window.location.reload();
  };

  const handlePress = async (url, clicked) => {
    console.log("uyghtgh", clicked);

    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      if (!clicked) {
        navigate("/cart");
      } else {
        const response = await api.post(`/user_api/cart/add-to-cart-web-home`, {
          access_token: JSON.parse(accessToken),
          product_url: url,
          qty: 1,
        });
        console.log("jyghjgjgjh", response.data);
        if (response.data.status === "success") {
          CardData();
        } else {
          console.log("something fisshy");
        }
      }
    } catch (error) {
      console.log("Error adding cart:", error);
    } finally {
    }
  };

  const addWishlist = async (id) => {
    if (!accessToken) {
      navigate("/login");
      return;
    }

    try {
      const response = await api.post(`user_api/add-wishlist`, {
        access_token: JSON.parse(accessToken),
        product_id: id,
      });

      CardData();
    } catch (error) {
      console.log("Error saving wishlist:", error);
    }
  };
  return (
    <div
      className="similar-products-container"
      style={{ width: "95%", margin: "auto", padding: "20px 0" }}
    >
      <h2
        className="section-title"
        style={{
          fontSize: "clamp(1.5rem, 2.5vw, 2.2rem)",
          marginBottom: "30px",
          position: "relative",
          display: "inline-block",
        }}
      >
        <span
          className="title-highlight"
          style={{
            backgroundColor: "#ffd700",
            padding: "0 10px",
            borderRadius: "4px",
            boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
          }}
        >
          Similar
        </span>{" "}
        Products
      </h2>

      <div className="products-carousel">
        <Slider {...settings}>
          {cardImage.map((product) => (
            <div
              key={product.id}
              onClick={() => handelRefresh(product.product_url)}
              className="product-card-item"
              style={{
                height: "100%",
                margin: "0 10px",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                transition: "transform 0.3s ease",
                background: "#fff",
                display: "flex",
                flexDirection: "column",
                position: "relative",
              }}
            >
              <div className="discount-badge pulse-animation" style={{}}>
                {product.discout}% OFF
              </div>
              <div
                className="wishlist-icon5"
                onClick={(e) => {
                  e.stopPropagation();
                  addWishlist(product.id);
                }}
              >
                <FaHeart
                  style={{
                    color: product.wish_button === "checked" ? "red" : "gray",
                  }}
                />
              </div>

              <div
                className="product-image-wrapper"
                style={{
                  height: "200px",
                  width: "100%",
                  position: "relative",
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  backgroundColor: "#f8f9fa",
                }}
              >
                {product.product_image_path?.[0]?.real_image_path ? (
                  <img
                    src={product.product_image_path[0].real_image_path}
                    alt={product.product_name}
                    className="product-card-image hover-zoom"
                    style={{
                      height: "100%",
                      width: "100%",
                      objectFit: "contain",
                      transition: "transform 0.3s ease",
                    }}
                    loading="lazy"
                    onMouseEnter={(e) =>
                      (e.currentTarget.style.transform = "scale(1.05)")
                    }
                    onMouseLeave={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />
                ) : (
                  <div
                    className="image-placeholder"
                    style={{
                      height: "100%",
                      width: "100%",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      color: "#6c757d",
                    }}
                  >
                    <i
                      className="fas fa-image"
                      style={{ fontSize: "2rem" }}
                    ></i>
                  </div>
                )}
              </div>

              <div className="product-info4">
                <h4
                  className=""
                  style={{
                    margin: "5px 0",
                    fontSize: "16px",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    width: "98%",
                  }}
                >
                  {product.product_name}
                </h4>

                <div
                  className="product-pricing"
                  style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    paddingBottom: "10px",
                    width: "100%",
                  }}
                >
                  <span className="selling-price">
                    AED{product.selling_price}
                  </span>
                  {product.initial_cost && (
                    <span
                      className="original-price"
                      style={{
                        fontSize: "0.9rem",
                        color: "#7f8c8d",
                        textDecoration: "line-through",
                        marginLeft: "8px",
                      }}
                    >
                      AED{product.initial_cost}
                    </span>
                  )}
                </div>

                <button
                  className="add-to-cart-btn"
                  onClick={(e) => {
                    e.stopPropagation();
                    handlePress(product.product_url, product.add_to_cart);
                  }}
                >
                  <i className="fas fa-shopping-cart"></i>
                  <span>
                    {product.add_to_cart ? "ADD TO CART" : "GO TO CART"}
                  </span>
                </button>
              </div>
            </div>
          ))}
        </Slider>
      </div>

      <style jsx>{`
        @keyframes pulse {
          0% {
            transform: scale(1);
          }
          50% {
            transform: scale(1.05);
          }
          100% {
            transform: scale(1);
          }
        }

        .product-card-item:hover {
          transform: translateY(-5px);
          box-shadow: 0 8px 20px rgba(0, 0, 0, 0.15);
        }
      `}</style>
    </div>
  );
}

export default Similar_Product;
